import type { ExpectedFormat } from './ExpectedFormat'

/** Locale noun key for every `expected_format` the API emits on FIELD_INVALID_FORMAT. */
export const expectedFormatKey = Object.freeze({
  category_id_or_all: 'presentation.errors.expectedFormat.categoryIdOrAll',
  date: 'presentation.errors.expectedFormat.date',
  date_range: 'presentation.errors.expectedFormat.dateRange',
  decimal: 'presentation.errors.expectedFormat.decimal',
  email: 'presentation.errors.expectedFormat.email',
  image: 'presentation.errors.expectedFormat.image',
  no_emoji: 'presentation.errors.expectedFormat.noEmoji',
  password: 'presentation.errors.expectedFormat.password',
  pattern: 'presentation.errors.expectedFormat.pattern',
  phone: 'presentation.errors.expectedFormat.phone',
  positive_integer_or_infinity: 'presentation.errors.expectedFormat.positiveIntegerOrInfinity',
  public_url: 'presentation.errors.expectedFormat.publicUrl',
  resolvable_location: 'presentation.errors.expectedFormat.resolvableLocation',
  time: 'presentation.errors.expectedFormat.time',
  timezone: 'presentation.errors.expectedFormat.timezone',
  url: 'presentation.errors.expectedFormat.url',
  utf8: 'presentation.errors.expectedFormat.utf8',
  uuid: 'presentation.errors.expectedFormat.uuid'
} satisfies Record<ExpectedFormat, `presentation.errors.expectedFormat.${string}`>)
